module.exports = __webpack_public_path__ + "src/assets/img/2.42a5e4bb.jpg";